import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { MdbButtonModule, MdbModalService, MdbRippleModule, MdbSelectModule } from 'mdb5-adapted';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { ClientDetailsService } from 'src/app/core/rest-services/client-details.service';
import { UserService } from 'src/app/core/services/lmsuser.service';

import { LMSConstantsService } from '@lmsConstants';
import { RiskScoreModel } from '@lmsModels';
import { LmsTableWrapperComponent } from '@lmsShared';
import { AddRiskScoreComponent } from './add-risk-score/add-risk-score.component';
import { RiskScoreRemoveDialogComponent } from './risk-score-remove-dialog/risk-score-remove-dialog.component';
import { RiskScoresEditDialogComponent } from './risk-scores-edit-dialog/risk-scores-edit-dialog.component';
import { RiskScoresService } from './risk-scores.service';

@Component({
  selector: 'app-risk-scores',
  templateUrl: './risk-scores.component.html',
  styleUrls: ['./risk-scores.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbButtonModule,
    MdbRippleModule,
    MdbSelectModule,
    NgxPaginationModule,
    LmsTableWrapperComponent,
  ],
})
export class RiskScoresComponent implements OnInit, AfterViewInit {
  riskScoreModel: RiskScoreModel = new RiskScoreModel();
  lstParemeterType: any;
  riskScoresForm: FormGroup;

  items: any[];
  public config: PaginationInstance = {
    id: 'pager',
    itemsPerPage: 10,
    currentPage: 1,
  };
  // @Output() changePage = new EventEmitter<any>(true);
  // @Input() initialPage = 1;
  // @Input() pageSize = 8;
  // @Input() maxPages = 3;

  // pager: number;

  constructor(
    private clientDetailsService: ClientDetailsService,
    public riskScoreService: RiskScoresService,
    private userService: UserService,
    private lmsDialog: MdbModalService,
    private formBuilder: FormBuilder,
    private lmsConstantsService: LMSConstantsService,
  ) {
    this.lstParemeterType = this.lmsConstantsService.getLMSConstant('PARAMETER_TYPES') || [];
  }
  ngAfterViewInit(): void {
    this.findAll();
  }

  ngOnInit(): void {
    this.riskScoresForm = this.formBuilder.group({
      parameterType: [this.riskScoreModel.parameterType, [Validators.required]],
    });
  }

  findAll() {
    this.clientDetailsService.findAll().subscribe((result: any) => {
      this.riskScoreModel.parameterType = '';
      this.items = result;
    });
  }

  findByParameterType(pType: any) {
    this.riskScoreService.findByParameterType(pType).subscribe((result: any) => {
      console.log('Score card Details: ', result);
      this.items = result;
    });
  }

  removeRiskScore(score: any) {
    this.riskScoreService.setRiskScorecard(score);
    this.riskScoreModel = new RiskScoreModel();
    this.riskScoreModel.id = score.id;
    this.riskScoreModel.parameterType = score.parameterType;
    this.riskScoreModel.description = score.description;
    this.riskScoreModel.score = score.score;

    const dialogRef = this.lmsDialog.open(RiskScoreRemoveDialogComponent, {
      modalClass: 'modal-dialog-centered d-flex modal-xl',
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: true,
      data: { riskScorecard: this.riskScoreModel }
    });

    dialogRef.onClose.subscribe((result) => {
      result.id = this.riskScoreService.riskScorecard.id;
      result.userName = this.userService.userLoginName;

      this.riskScoreService.removeScorecard(this.riskScoreService.riskScorecard.id).subscribe((res: any) => {
        this.items = res;
        this.findByParameterType(this.riskScoreModel.parameterType);
      });
    });
  }

  editRiskScore(score: any) {
    this.riskScoreService.setRiskScorecard(score);

    const userName = this.userService.userLoginName;

    this.riskScoreModel = new RiskScoreModel();
    this.riskScoreModel.id = score.id;
    this.riskScoreModel.updatedBy = userName;
    this.riskScoreModel.updatedOn = new Date();
    this.riskScoreModel.parameterType = score.parameterType;
    this.riskScoreModel.description = score.description;
    this.riskScoreModel.score = score.score;

    const dialogRef = this.lmsDialog.open(RiskScoresEditDialogComponent, {
      modalClass: 'modal-dialog-centered d-flex modal-xl',
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: true,
      data: { riskScorecard: this.riskScoreModel }
    });

    dialogRef.onClose.subscribe((result) => {
      result.id = this.riskScoreService.riskScorecard.id;
      result.updatedBy = this.userService.userLoginName;
      result.updatedOn = Date.now();

      this.riskScoreService.updateRiskScoreData(result).subscribe((res: any) => {
        this.riskScoreService.riskScorecard = res;
        this.findByParameterType(this.riskScoreService.riskScorecard.parameterType);
        this.riskScoreModel.parameterType = this.riskScoreService.riskScorecard.parameterType;
      });
    });
  }

  addRiskScore() {
    const dialogRef = this.lmsDialog.open(AddRiskScoreComponent,
      {
        modalClass: 'modal-dialog-centered d-flex modal-md',
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: true,
        data: {}
     });

    dialogRef.onClose.subscribe((result) => {
      if (result) {
        result.createdBy = this.userService.userLoginName;
        result.updatedBy = this.userService.userLoginName;
        result.createdOn = Date.now();
        result.updatedOn = Date.now();

        this.riskScoreService.saveRiskScoreData(result).subscribe((res) => {
          this.riskScoreModel = res;
          this.findByParameterType(this.riskScoreModel.parameterType);
        });
      }
    });
  }
}
